import Image from 'next/image';

export const VeradigmPolicyModal = ({
  tenantBranding,
}: {
  tenantBranding?: string | null;
}) => {
  return (
    <main className="fixed inset-0 z-50 grid min-h-screen w-screen place-items-center bg-white">
      <div className="flex h-full w-full items-center justify-center p-8">
        <div className="flex flex-col items-center justify-center">
          <div className="flex flex-col items-center gap-4">
            <Image
              alt="Branding Logo"
              className=""
              height={tenantBranding ? 70 : 75}
              priority
              src={tenantBranding ?? '/brand-icon.svg'}
              width={tenantBranding ? 198 : 75}
            />

            <h1 className="mb-4 pt-5 text-[2rem] font-semibold leading-10">
              📄 Acceptance of Terms & Conditions Required
            </h1>
          </div>
          <div className="bg-table-background flex min-h-96 w-full max-w-xl flex-col items-center gap-4 rounded-md p-6 pt-0 text-center">
            <p className="mb-6">
              To begin using Ambient Scribe, you must review and accept the
              Terms & Conditions, including the standard $1 per encounter
              billing fee.
            </p>

            <p className="mb-8">
              Click below to be redirected. Once you have accepted the terms,
              access to Ambient Scribe will be granted.
            </p>

            <div className="flex w-full flex-col items-center gap-4">
              <a
                className="text-primary font-medium hover:underline"
                href="https://s882v.share.hsforms.com/21OI0HeS5SlKMRFOEwRIB5g"
                rel="noopener noreferrer"
                target="_blank"
              >
                Review and Accept Terms
              </a>
            </div>
            <p>
              <span className="font-black">Note:</span> You will not be able to
              access Ambient Scribe until this step is complete. This message
              will reappear until your acceptance is received.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};
